import React, { Component, Fragment } from 'react';
import { FaSearch } from 'react-icons/fa';
import { connect } from 'react-redux';
import { firestoreConnect, isLoaded } from 'react-redux-firebase';
import { compose } from 'redux';
import {
  Col,
  Container,
  FormInput,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from 'shards-react';
import { TilesComponent } from '../../common/dashboard/TilesComponent/TilesComponent';
import LoadingComponent from '../../common/loading/LoadingComponent';
import { closeModal, openModal } from '../../common/modals/modalActions';
import {
  createComplaint,
  sendEmail,
  updateComplaint,
} from '../Dashboard/Complaint/complaintActions';
import ComplaintList from '../Dashboard/Complaint/ComplaintList/ComplaintList';
import {
  isNewUser,
  updateLastLogin,
  updateProfile,
} from '../Dashboard/UpdateProfile/profileActions';
import { searchQueries } from './archiveQueries';

const mapState = (state) => ({
  complaints: state.firestore.ordered.complaints || [],
  auth: state.firebase.auth,
  firebase: state.firebase,
  profile: state.firebase.profile,
  loading: state.async.loading,
  progress: [],
});

const actions = {
  createComplaint,
  updateComplaint,
  openModal,
  closeModal,
  sendEmail,
  updateProfile,
  isNewUser,
  updateLastLogin,
};

class Search extends Component {
  state = {
    filteredList: [],
    search: '',
  };

  filterList = (event) => {
    let items = this.props.complaints;
    if (event.target.value !== undefined || event.target.value !== '') {
      items = items.filter((item) => {
        if (item.tags && item.tags.length > 0) {
          let keys = item.tags;

          if (event.target.value !== '' && keys && keys.length > 0) {
            for (const key of keys) {
              if (
                key.toLowerCase().search(event.target.value.toLowerCase()) !==
                -1
              ) {
                //console.log(`match ${key} - ${event.target.value}`);
                return true;
              }
            }
          }
        } else {
          return;
        }
      });
    } else {
      items = this.props.complaints;
    }
    this.setState({ filteredList: items });
  };

  render() {
    const { complaints, history } = this.props;
    const { filteredList } = this.state;

    if (!isLoaded(complaints)) return <LoadingComponent loading={true} />;

    return (
      <Container fluid className='h-100 my-3'>
        <h5 className='text-capitalize'>Search Tickets</h5>
        <div className='tiles'>
          <TilesComponent complaints={this.props.complaints} />
        </div>

        <Fragment>
          <Col>
            <InputGroup>
              <InputGroupAddon type='prepend'>
                <InputGroupText>
                  <FaSearch />
                </InputGroupText>
              </InputGroupAddon>
              <FormInput
                type='text'
                placeholder='Search'
                onChange={(e) => this.setState({ search: e.target.value })}
                onKeyDown={this.filterList}
                value={this.state.search}
              />
            </InputGroup>
          </Col>

          {complaints && complaints.length > 0 ? (
            <ComplaintList
            archive={false}
              complaints={this.state.search !== '' ? filteredList : complaints}
              history={history}
            />
          ) : (
            ''
          )}
        </Fragment>
      </Container>
    );
  }
}

export default compose(
  connect(mapState, actions),
  firestoreConnect((auth, profile) => searchQueries(auth, profile))
)(Search);
